import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { CentBasedInputCurrency } from '../Input/InputCurrency';
import Switch from '../Input/Switch';
import { Label, Text } from '../Typography';

const Layout = styled.section`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: auto;

  input {
    display: flex;
  }
`;

const Inner = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: auto;
  margin-right: ${toRem(11)};

  label {
    margin-right: ${toRem(11)};
    font-size: ${toRem(12)};
    color: ${theme.color.neutral[800]};
  }
`;

const LabelWrapper = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: auto;
  margin-right: ${toRem(11)};

  label {
    margin-right: ${toRem(11)};
    font-size: ${toRem(11)};
    color: ${theme.color.neutral[800]};
  }

  p {
    margin-right: ${toRem(11)};
    font-size: ${toRem(11)};
    color: ${theme.color.neutral[700]};
  }
`;

interface ITipPoolLimitProps {
  className?: string;
  isActive?: boolean;
  onChange?: (value: string, name?: any) => void;
  onToggle?: () => void;
  defaultValue?: number;
  value?: number;
  isStrict?: boolean;
}

const TipPoolLimit = ({ className, isActive, onChange, onToggle, value, isStrict = false, ...props }: ITipPoolLimitProps) => {
  const [inputActive, setInputActive] = useState<boolean>(isActive || false);

  const handleToggle = () => {
    setInputActive(!inputActive);
    onToggle?.();
  };

  return (
    <Layout className={className} {...props}>
      {!isStrict ? (
        <Inner>
          <Label>Payout Limit</Label>
          <Switch checked={inputActive} onChange={handleToggle} data-cy="tip-pool-limit-toggle" />
        </Inner>
      ) : (
        <LabelWrapper>
          <Label>Payout Limit</Label>
          <Text className={isEmpty(value) ? 'error' : ''}>(Required)</Text>
        </LabelWrapper>
      )}

      <CentBasedInputCurrency
        width={98}
        height={33}
        maxCurrencyLength={7}
        disabled={!inputActive && !isStrict}
        value={value === undefined ? '' : value.toString()}
        onChange={(val: string) => {
          onChange?.(val);
        }}
        data-cy="tip-pool-limit-input"
      />
    </Layout>
  );
};

export default TipPoolLimit;
